import BooksPreview from './component';

export const initialState = {};
export const reducer = state => state;
export const component = BooksPreview;
